"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _API2 = _interopRequireDefault(require("./API"));

var _LanguageUtil = _interopRequireDefault(require("../util/LanguageUtil"));

var URL = '/websitegrader/v2/form/submission';
var SUB_SOURCE = 'Website Grader 2015'; // Only supported subscriber languages are listed here (exluding English)

var supportedSubscriberlanguages = {
  de: 'German',
  es: 'Spanish',
  fr: 'French',
  ja: 'Japanese',
  pt: 'Portuguese'
};
var ENGLISH = 'English';
var hubspotutk;
window._hsq = window._hsq || [];

window._hsq.push(['addUserTokenListener', function (userToken) {
  hubspotutk = userToken;
}]);

var _default =
/*#__PURE__*/
function (_API) {
  (0, _inherits2.default)(_default, _API);

  function _default() {
    (0, _classCallCheck2.default)(this, _default);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(_default).apply(this, arguments));
  }

  (0, _createClass2.default)(_default, [{
    key: "getSubscriberLanguage",
    value: function getSubscriberLanguage() {
      var userLanguage = _LanguageUtil.default.getUserLanguage();

      return supportedSubscriberlanguages[userLanguage];
    }
  }, {
    key: "getSubscriberSource",
    value: function getSubscriberSource(subscriberLanguage) {
      if (!subscriberLanguage) {
        return SUB_SOURCE;
      } // E.g. Website Grader German 2015


      return "Website Grader " + subscriberLanguage + " 2015";
    }
    /**
     * Save the contact in the HubSpot portal/form provided.
     */

  }, {
    key: "save",
    value: function save(contactEmail, websiteGrade) {
      var subscriberLanguage = this.getSubscriberLanguage();
      var subscriberSource = this.getSubscriberSource(subscriberLanguage);

      var getDateAtMidnight = function getDateAtMidnight() {
        return new Date().setUTCHours(0, 0, 0, 0);
      };

      var data = {
        formData: {
          content_language: subscriberLanguage || ENGLISH,
          email: contactEmail,
          lifecyclestage: 'subscriber',
          subscribersource_2: subscriberSource,
          wg_recent_website_url: websiteGrade.get('domain'),
          wg_recent_report_url: location.href,
          wg_overall_score: websiteGrade.get('overallGrade'),
          wg_performance_score: websiteGrade.getIn(['performanceAudit', 'grade']),
          wg_mobile_responsiveness_score: websiteGrade.getIn(['mobileAudit', 'grade']),
          wg_seo_score: websiteGrade.getIn(['seoAudit', 'grade']),
          wg_security_score: websiteGrade.getIn(['securityAudit', 'grade']),
          wg_submission_date: getDateAtMidnight()
        },
        hutk: hubspotutk,
        pageUri: window.location.href
      };
      return this.makePostRequest(URL, {
        data: data
      });
    }
  }]);
  return _default;
}(_API2.default);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/api/ContactAPI.js
// module id = 253
// module chunks = 0